/**
 *
 */
export enum OwnerTypeID {
  PrivateOwner = 1,
  RealEstateAgent = 4,
  Other = 8,
}
